const UXFeedback = {
    sendEvent(eventName: string): void {
        window.dispatchEvent(
            new CustomEvent('HH-UXFeedback-Open', {
                detail: eventName,
            })
        );
    },
};

export default UXFeedback;
